export default __webpack_public_path__ + "static/media/imgMapSearch.9a17ad73.png";